import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import { envAwarePost } from '../../util/util'

export const editProgram = createAsyncThunk(
	'programs/edit',
	async payload => await envAwarePost('api/programs/',{
		action:'editProgram',
		...payload
	})
)

export const linkEventToProgram = createAsyncThunk(
	'programs/linkEvent',
	async payload => await envAwarePost('api/programs/',{
		actions:['linkEventToProgram','getProgramEventLinks'],
		...payload
	})
)

export const updateProgramMessage = createAsyncThunk(
	'programrams/editMessage',
	async payload => await envAwarePost('api/programs/',{
		actions:['updateProgramMessage','getProgramEventLinks'],
		...payload
	})
)

export const deleteProgramMessage = createAsyncThunk(
	'programs/deleteMessage',
	async payload => await envAwarePost('api/programs/',{
		actions:['deleteProgramMessage','getProgramEventLinks'],
		...payload
	})
)

export const deleteProgramMessageGroup = createAsyncThunk(
	'programs/deleteMessage',
	async payload => await envAwarePost('api/programs/',{
		actions:['deleteProgramMessageGroup','getProgramEventLinks'],
		...payload
	})
)

export const editProgramEventLink = createAsyncThunk(
	'programs/editLinkedEvent',
	async payload => await envAwarePost('api/programs/',{
		actions:['editProgramEventLink','getProgramEventLinks'],
		...payload
	})
)

export const addMessagesToProgram = createAsyncThunk(
	'programs/addMessages',
	async payload => await envAwarePost('api/programs/',{
		actions:['addMessagesToProgram','getProgramEventLinks'],
		...payload
	})
)

export const removeProgramEventLink = createAsyncThunk(
	'programs/removeLinkedEvent',
	async payload => await envAwarePost('api/programs/',{
		actions:['removeProgramEventLink','getProgramEventLinks'],
		...payload
	})
)

export const createProgramEventLinkException = createAsyncThunk(
	'programs/createEventLinkException',
	async payload => await envAwarePost('api/programs/',{
		actions:['createProgramEventLinkException','getProgramEventLinks'],
		...payload
	})
)

export const rescheduleProgramEventLink = createAsyncThunk(
	'programs/createEventLinkException',
	async payload => await envAwarePost('api/programs/',{
		actions:[
			'createProgramEventLinkException',
			'linkEventToProgram',
			'getProgramEventLinks'
		],
		...payload
	})
)

export const copyProgram = createAsyncThunk(
	'programs/copy',
	async payload => await envAwarePost('api/programs/',{
		action:'copyProgram',
		...payload
	})
)

export const getProgramCategories = createAsyncThunk(
	'getProgramCategories',
	async () => envAwarePost('api/programs/', {
		action: 'getProgramCategories'
	})
)

//client api calls

export const getSelectablePrograms = createAsyncThunk(
	'getSelectablePrograms',
	async () => envAwarePost('api/programs/', {
		action: 'getPrograms'
	})
)

export const getActivePrograms = createAsyncThunk(
	'getActivePrograms',
	async () => envAwarePost('api/programs/', {
		action: 'getActivePrograms'
	})
)

export const enrollInProgram = createAsyncThunk(
	'enrollInProgram',
	async payload => envAwarePost('api/programs/', {
		action: 'assignProgramToSelf',
		...payload
	})
)

/**
 * This is for clients
 */
export const cancelProgram = createAsyncThunk(
	'cancelProgram',
	async payload => envAwarePost('api/programs/', {
		action: 'deleteProgramAssignment',
		...payload
	})
)

//applyOn Boarding
export const applyOnBoarding = createAsyncThunk(
	'applyOnBoarding',
	async payload => envAwarePost('api/programs/', {
		action: 'applyOnboarding',
		...payload
	})
)

//trainer api calls
export const deleteProgram = createAsyncThunk(
	'deleteProgram',
	async (payload) => envAwarePost('api/programs/', {
		action: 'deleteProgram',
		...payload
	})
)

export const getPrograms = createAsyncThunk(
	'getPrograms',
	async () => envAwarePost('api/programs/', {
		action: 'getPrograms'
	})
)

export const getProgramsChain = createAsyncThunk(
	'getProgramsChain',
	async payload => envAwarePost('api/programs/', {
		action: 'getProgramsChain',
		...payload
	})
)

export const getAutomationSettings = createAsyncThunk(
	'getAutomationSettings',
	async () => envAwarePost('api/programs/', {
		action: 'getAutomationSettings'
	})
)

export const updateAutomationSettings = createAsyncThunk(
	'updateAutomationSettings',
	async (payload) => envAwarePost('api/programs/api', {
		action: 'toggleAutomationTrigger',
		...payload
	})
)

export const createCategory = createAsyncThunk(
	'createCategory',
	async (name) => envAwarePost('api/programs/', {
		action: 'createCategory',
		name
	})
)

export const updateCategory = createAsyncThunk(
	'updateCategory',
	async (payload) => envAwarePost('api/programs/', {
		action: 'updateCategory',
		...payload
	})
)

export const deleteCategory = createAsyncThunk(
	'deleteCategory',
	async (category_id) => envAwarePost('api/programs/', {
		action: 'deleteCategory',
		category_id
	})
)

export const createCategoryOption = createAsyncThunk(
	'createCategoryOption',
	async category_id => envAwarePost('api/programs/', {
		action: 'createCategoryOption',
		category_id
	})
)

export const updateCategoryOption = createAsyncThunk(
	'updateCategoryOption',
	async payload => envAwarePost('api/programs/', {
		action: 'updateCategoryOption',
		...payload
	})
)

export const deleteCategoryOption = createAsyncThunk(
	'deleteCategoryOption',
	async payload => envAwarePost('api/programs/', {
		action: 'deleteCategoryOption',
		...payload
	})
)

export const categorizeProgram = createAsyncThunk(
	'categorizeProgram',
	async payload => envAwarePost('api/programs/', {
		action: 'categorizeProgram',
		...payload
	})
)

export const deleteCategorization = createAsyncThunk(
	'deleteCategorization',
	async payload => envAwarePost('api/programs/', {
		action: 'deleteCategorization',
		...payload
	})
)

export const updateClientSelectable = createAsyncThunk(
	'updateClientSelectable',
	async payload => envAwarePost('api/programs/', {
		action: 'updateClientSelectable',
		...payload
	})
)

export const getProgram = createAsyncThunk(
	'getProgram',
	async program_id => await envAwarePost(
		'api/programs/',
		{action:'getProgram',program_id}
	)
)

export const getProgramEventLinks = createAsyncThunk(
	'getProgramEventLinks',
	async program_id => await envAwarePost(
		'api/programs/',
		{action:'getProgramEventLinks',program_id}
	)
)

export const linkPackageToProgram = createAsyncThunk(
	'programs/linkPackage',
	async payload => await envAwarePost(
		'api/packages/',
		{action:'createProgramPackageLink',...payload}
	)
)

export const removeProgramPackageLink = createAsyncThunk(
	'programs/removePackageLink',
	async payload => await envAwarePost(
		'api/packages/',
		{action:'removeProgramPackageLink',...payload}
	)
)

const categoriesAdapter = createEntityAdapter()
const automationSettingsAdapter = createEntityAdapter()
const programsAdapter = createEntityAdapter({
	selectId: p => p.programID
})

const selectableProgramsAdapter = createEntityAdapter({
	selectId: p => p.programID
})

const activeProgramsAdapter = createEntityAdapter({
	selectId: p => p.assignment_id
})

const applyOnBoardingAdapter = createEntityAdapter()

const programsSlice = createSlice({
	name: 'programs',
	initialState: {
		assignmentsEditor: {
			show: false,
			program_id: null
		},
		assignModal: {
			show: false,
			program_id: null
		},
		copyModal:{
			show:false,
			program_id:null
		},
		eventLinkEditor:{
			show:false,
			isNew:true,
			link:null,
			eventMeta:null,
			clickedDay:1,
		},
		templatesModal:{
			show:false
		},
		categoryEditor: {
			show: false,
			status: 'idle'
		},
		programSettingsEditor: {
			show: false,
			program_id: null,
		},
		//map from program id to boolean
		//if true then that program is currently being fetched from backend services
		pending:{
			programs:{},
			eventLinks:{}
		},
		automationSettings: automationSettingsAdapter.getInitialState(),
		categories: categoriesAdapter.getInitialState(),
		programs: programsAdapter.getInitialState({
			status:'init'
		}),
		eventLinks:{},
		selectablePrograms: selectableProgramsAdapter.getInitialState(),
		activePrograms: activeProgramsAdapter.getInitialState(),
		applyOnBoardingValue: applyOnBoardingAdapter.getInitialState()

	},
	reducers: {
		updateEventLinkEditor: (state,action)=>{
			state.eventLinkEditor = {
				...state.eventLinkEditor,
				...action.payload
			}
		},
		editProgramAssignments: (state, action) => {
			state.assignmentsEditor.show = true
			state.assignmentsEditor.program_id = action.payload
		},
		closeProgramAssignments: (state) => {
			state.assignmentsEditor.show = false
		},
		addProgramAssignments: (state, action) => {
			state.assignModal.show = true
			state.assignModal.program_id = action.payload
		},
		closeAssignModal: (state) => {
			state.assignModal.show = false
		},
		editProgramSettings: (state, action) => {
			state.programSettingsEditor.program_id = action.payload
			state.programSettingsEditor.show = true
		},
		closeProgramSettings: (state) => {
			state.programSettingsEditor.show = false
		},
		toggleCategoryEditor: (state, action) => {
			state.categoryEditor.show = action.payload
		},
		setCopyModal: (state,action) => {
			state.copyModal.show = action.payload.show
			state.copyModal.program_id = action.payload.program_id
		},
		setTemplatesModal: (state,action) => {
			state.templatesModal.show = action.payload.show
		}
	},
	extraReducers: {
		[editProgram.pending] : (state,action)=>{
			const {program_id:id,update:changes} = action.meta.arg
			programsAdapter.updateOne(state.programs,{id,changes})
		},
		[copyProgram.fulfilled] : (state,action)=>{
    		const {success,data} = action.payload
    		if (success === '1') {
    			if(data.program){
    				programsAdapter.upsertOne(state.programs,data.program)	
    			}else if(data.copies){
    				programsAdapter.upsertMany(state.programs,data.copies)
    			}
    			
    		}
    	},
		[deleteProgram.pending]: (state, action) => {
			const { program_id } = action.meta.arg
			programsAdapter.removeOne(state.programs, program_id)
		},
		//category reducers
		[getProgramCategories.pending]: state => {
			state.categories.status = 'loading'
		},
		[getProgramCategories.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.categories.status = 'loaded'
				categoriesAdapter.upsertMany(state.categories, data)
			} else {
				alert(message)
			}
		},

		//automationSettings reducers
		[getAutomationSettings.pending]: state => {
			state.automationSettings.status = 'loading'
		},

		[getAutomationSettings.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.automationSettings.status = 'loaded'
				automationSettingsAdapter.upsertMany(state.automationSettings, data)
			} else {
				alert(message)
			}
		},

		[getAutomationSettings.rejected]: (state) => {
			state.automationSettings.status = 'failed'
		},

		[updateAutomationSettings.pending]: (state, action) => {
			const { enabled, automation_trigger_id: id } = action.meta.arg
			automationSettingsAdapter.updateOne(state.automationSettings, {
				id,
				changes: { enabled }
			})
		},


		[updateAutomationSettings.failed]: (state, action) => {
			state.automationSettings.status = 'failed'
		},

		// programs reducers
		[getPrograms.pending]: state => {
			state.programs.status = 'loading'
		},
		[getPrograms.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.programs.status = 'loaded'
				programsAdapter.upsertMany(state.programs, data)
			} else {
				alert(message)
			}
		},

		[getProgramsChain.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.programs.status = 'loaded'
				programsAdapter.setAll(state.programs, data.programs)
			} else {
				alert(message)
			}
		},

		[getPrograms.rejected]: (state) => {
			state.programs.status = 'failed'
		},

		// category reducers
		[createCategory.pending]: (state) => {
			state.categoryEditor.status = 'pending'
		},

		[createCategory.fulfilled]: (state, action) => {
			const { arg: name } = action.meta
			const { success, data, message } = action.payload
			state.categoryEditor.status = 'idle'
			if (success === '1') {
				categoriesAdapter.addOne(state.categories, {
					id: data,
					options: [],
					name,
				})
			} else {
				alert(message)
			}
		},

		[createCategory.rejected]: (state) => {
			state.categoryEditor.status = 'idle'
		},

		[updateCategory.pending]: (state, action) => {
			const { name, category_id } = action.meta.arg
			categoriesAdapter.updateOne(state.categories, {
				id: category_id,
				changes: { name }
			})
		},

		[deleteCategory.pending]: (state, action) => {
			const { arg: category_id } = action.meta
			categoriesAdapter.removeOne(state.categories, category_id)
		},

		[deleteCategory.fulfilled]: (state, action) => {
			const { success, message } = action.payload
			if (success !== '1') alert(message)
		},

		[createCategoryOption.pending]: (state) => {
			state.categoryEditor.status = 'pending'
		},

		[createCategoryOption.rejected]: (state) => {
			state.categoryEditor.status = 'pending'
		},

		[createCategoryOption.fulfilled]: (state, action) => {
			const { arg: category_id } = action.meta
			const { success, data, message } = action.payload
			state.categoryEditor.status = 'idle'
			if (success === '1') {
				state.categories.entities[category_id].options.push({
					name: '',
					id: data,
					category_id
				})
			} else {
				alert(message)
			}
		},

		[updateCategoryOption.pending]: (state, action) => {
			const { name, option_id, category_id } = action.meta.arg
			state.categories.entities[category_id].options.forEach(option => {
				if (option.id === option_id) {
					option.name = name
				}
			})
		},

		[deleteCategoryOption.pending]: (state, action) => {
			const { option_id, category_id } = action.meta.arg
			const optionsUpdate = state.categories.entities[category_id].options.filter(item => {
				return item.id !== option_id
			})
			state.categories.entities[category_id].options = optionsUpdate
		},

		[categorizeProgram.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			const { program_id } = data
			const categorization = state.programs.entities[program_id].categorization
			programsAdapter.updateOne(state.programs, {
				id: program_id,
				changes: {
					categorization: [...categorization, data]
				}
			})
		},

		[deleteCategorization.pending]: (state, action) => {
			const { program_id, categorization_id } = action.meta.arg
			const categorization = state.programs.entities[program_id].categorization
			const categorizationUpdate = categorization.filter(cat => cat.id !== categorization_id)
			programsAdapter.updateOne(state.programs, {
				id: program_id,
				changes: {
					categorization: categorizationUpdate
				}
			})
		},

		[updateClientSelectable.pending]: (state, action) => {
			const { program_id, client_selectable } = action.meta.arg
			programsAdapter.updateOne(state.programs, {
				id: program_id,
				changes: {
					isClientSelectable: client_selectable
				}
			})
		},
		//category reducers
		[getProgramCategories.pending]: state => {
			state.categories.status = 'loading'
		},
		[getProgramCategories.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.categories.status = 'loaded'
				categoriesAdapter.upsertMany(state.categories, data)
			} else {
				alert(message)
			}
		},
		[getSelectablePrograms.rejected]: (state) => {
			state.selectablePrograms.status = 'failed'
		},

		//selectable programs reducers
		[getSelectablePrograms.pending]: state => {
			state.selectablePrograms.status = 'loading'
		},
		[getSelectablePrograms.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.selectablePrograms.status = 'loaded'
				selectableProgramsAdapter.upsertMany(state.selectablePrograms, data)
			} else {
				alert(message)
			}
		},
		[getSelectablePrograms.rejected]: (state) => {
			state.selectablePrograms.status = 'failed'
		},

		//active programs reducers
		[getActivePrograms.pending]: state => {
			state.activePrograms.status = 'loading'
		},
		[getActivePrograms.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				state.activePrograms.status = 'loaded'
				activeProgramsAdapter.upsertMany(state.activePrograms, data)
			} else {
				alert(message)
			}
		},
		[getActivePrograms.rejected]: (state) => {
			state.activePrograms.status = 'failed'
		},

		//applyOnBoarding reducers
		[applyOnBoarding.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				applyOnBoardingAdapter.addOne(state.applyOnBoardingValue, data)
			} else {
				alert(message)
			}
		},
		//enrollment reducers
		[enrollInProgram.fulfilled]: (state, action) => {
			const { success, data, message } = action.payload
			if (success === '1') {
				activeProgramsAdapter.addOne(state.activePrograms, data)
			} else {
				alert(message)
			}
		},
		[cancelProgram.fulfilled]: (state, action) => {
			const { success, message } = action.payload
			if (success === '1') {
				const { assignment_id } = action.meta.arg
				activeProgramsAdapter.removeOne(state.activePrograms, assignment_id)
			} else {
				alert(message)
			}

		},
		[getProgram.pending]: (state,action) => {
			state.pending.programs[action.meta.arg] = true
		},
		[getProgram.fulfilled]: (state,action) => {
			state.pending.programs[action.meta.arg] = false
			const {success,data} = action.payload
			if (success!=='1') return 
			programsAdapter.upsertOne(state.programs,data)
		},
		[getProgramEventLinks.pending]: (state,action) => {
			state.pending.eventLinks[action.meta.arg] = true
		},
		[getProgramEventLinks.fulfilled]: (state,action) => {
			const program_id = action.meta.arg
			state.pending.eventLinks[program_id] = false
			state.eventLinks[program_id] = action.payload.data
		},
		[linkEventToProgram.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[addMessagesToProgram.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[updateProgramMessage.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[deleteProgramMessage.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[deleteProgramMessageGroup.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[removeProgramEventLink.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[editProgramEventLink.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[createProgramEventLinkException.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[rescheduleProgramEventLink.fulfilled]: (state,action)=>{
			const {program_id} = action.meta.arg
			state.eventLinks[program_id] = action.payload.getProgramEventLinks.data
		},
		[linkPackageToProgram.pending]: (state,action)=>{
			const {program_id,package_id,package_name} = action.meta.arg
			state.programs.entities[program_id].packages.push({package_id,package_name})
		},
		[removeProgramPackageLink.pending]: (state,action)=>{
			const {program_id,package_id} = action.meta.arg
			const program = state.programs.entities[program_id]
			program.packages = program.packages.filter(p=>p.package_id!==package_id)
		}
	}
})

export const {
	updateEventLinkEditor,
	updateEditor,
	toggleCategoryEditor,
	editProgramSettings,
	closeProgramSettings,
	editProgramAssignments,
	closeProgramAssignments,
	closeAssignModal,
	addProgramAssignments,
	setCopyModal,
	setTemplatesModal
} = programsSlice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllCategories,
	selectById: selectCategoryById,
	selectIds: selectCategoryIds
} = categoriesAdapter.getSelectors(state => state.programs.categories)

export const {
	selectAll: selectAllAutomationSettings,
	selectById: selectAutomationById,
} = automationSettingsAdapter.getSelectors(state => state.programs.automationSettings)

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllPrograms,
	selectById: selectProgramById,
	selectIds: selectProgramIds
} = programsAdapter.getSelectors(state => state.programs.programs)

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllSelectablePrograms,
	selectById: selectSelectableProgramById,
	selectIds: selectSelectableProgramIds
} = selectableProgramsAdapter.getSelectors(state => state.programs.selectablePrograms)

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllActives,
	selectById: selectActiveById,
	selectIds: selectActiveIds
} = activeProgramsAdapter.getSelectors(state => state.programs.activePrograms)

export const selectCopyModal = state=>state.programs.copyModal

export const selectTemplatesModal = state=>state.programs.templatesModal


export default programsSlice.reducer